import { useTranslation } from 'react-i18next';
import { Datagrid, Stack } from '@efast_public/fjd-component-library';
import {
  ScheduledTaskExecution,
  SUBMISSION_PICKUP_TASK_NAME,
  useScheduledTasks
} from '../../../../api/hooks/useScheduledTasks';

export default function SubmissionTasksTab() {
  const { t } = useTranslation();
  const { data: tasks, isLoading } = useScheduledTasks(
    SUBMISSION_PICKUP_TASK_NAME
  );

  return (
    <Stack spacing="l">
      <Datagrid<ScheduledTaskExecution>
        data={tasks ?? []}
        dataKey="id"
        areColumnsResizeable
        manualSorting={true}
        isDataLoading={isLoading}
        tableHeight={540}
        labels={{
          currentPage: 'Aktuelle Seite',
          detailButton: 'Weitere Infos ein-/ausblenden',
          emptyData: t('weiterleitung.scheduledTasks.empty'),
          nextPage: 'Nächste Seite',
          of: 'Seite {0} von {1}',
          page: 'Seite',
          pageSize: '{0} Einträge pro Seite',
          previousPage: 'Vorherige Seite',
          rows: 'Zeilen',
          tableTitle: t('weiterleitung.tabs.scheduledTasks'),
          ascBtn: 'Aufsteigend sortieren',
          descBtn: 'Absteigend sortieren',
          hideBtn: 'Spalte ausblenden'
        }}
        columns={[
          {
            id: 'destinationId',
            header: t('weiterleitung.scheduledTasks.col.destinationId'),
            accessorFn: (row) => row.data?.destinationId ?? '–',
            minSize: 300
          },
          {
            id: 'submissionId',
            header: t('weiterleitung.scheduledTasks.col.submissionId'),
            accessorFn: (row) => row.data?.submissionId ?? '–',
            minSize: 300
          },
          {
            id: 'mandantId',
            header: t('weiterleitung.scheduledTasks.col.mandantId'),
            accessorFn: (row) => row.data?.mandantId ?? '–'
          },
          {
            id: 'executionTime',
            header: t('weiterleitung.scheduledTasks.col.executionTime'),
            accessorKey: 'executionTime',
            cell: (row) =>
              new Date(row.getValue<string>()).toLocaleString('de-DE'),
            minSize: 200
          },
          {
            id: 'picked',
            header: t('weiterleitung.scheduledTasks.col.picked'),
            accessorKey: 'picked',
            cell: (row) =>
              row.getValue<boolean>()
                ? t('weiterleitung.scheduledTasks.yes')
                : t('weiterleitung.scheduledTasks.no')
          },
          {
            id: 'consecutiveFailures',
            header: t('weiterleitung.scheduledTasks.col.consecutiveFailures'),
            accessorKey: 'consecutiveFailures'
          },
          {
            id: 'lastFailure',
            header: t('weiterleitung.scheduledTasks.col.lastFailure'),
            accessorKey: 'lastFailure',
            cell: (row) => {
              const val = row.getValue<string | null>();
              return val ? new Date(val).toLocaleString('de-DE') : '–';
            }
          }
        ]}
      />
    </Stack>
  );
}
